var _path, _path2, _path3, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_128_9042)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_128_9042",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 70,
    height: 70
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.3334 0.666656H0.666748V69.3333H69.3334V0.666656Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_128_9042)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2805 26.0027L30.2858 43.9973L21.7195 35.4312",
    stroke: "#01B47E",
    strokeWidth: 5.36458,
    strokeMiterlimit: 10,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_128_9042",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 70,
    height: 70
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.666748 0.666664H69.3334V69.3333H0.666748V0.666664Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_128_9042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.6512 35C66.6512 52.4804 52.4805 66.6511 35.0002 66.6511C17.5198 66.6511 3.34912 52.4804 3.34912 35C3.34912 17.5196 17.5198 3.34897 35.0002 3.34897C52.4805 3.34897 66.6512 17.5196 66.6512 35Z",
    stroke: "#01B47E",
    strokeWidth: 5.36458,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_128_9042"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68.6667,
    height: 68.6667,
    fill: "white",
    transform: "translate(0.666748 0.666656)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.cac8f5c06bef120a490d8254dabb7808.svg";
export { ForwardRef as ReactComponent };